import { jwtDecode } from 'jwt-decode';
import apiClient from './api-client';
import { API_ENDPOINTS, AUTH_STORAGE_KEY } from '../config/api';
import type { LoginRequest, JwtTokenResponse, JwtPayload, AuthUser } from '../types/auth';

export const authService = {
  async login(credentials: LoginRequest): Promise<string> {
    const response = await apiClient.post<JwtTokenResponse>(
      API_ENDPOINTS.AUTH.LOGIN,
      credentials
    );
    const token = response.data.jwToken;
    localStorage.setItem(AUTH_STORAGE_KEY, token);
    return token;
  },

  logout(): void {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    window.location.href = '/login';
  },

  getToken(): string | null {
    return localStorage.getItem(AUTH_STORAGE_KEY);
  },

  isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) return false;
    try {
      const decoded = jwtDecode<JwtPayload>(token);
      return decoded.exp * 1000 > Date.now();
    } catch {
      return false;
    }
  },

  getCurrentUser(): AuthUser | null {
    const token = this.getToken();
    if (!token) return null;
    try {
      const decoded = jwtDecode<JwtPayload>(token);
      return {
        userId: decoded.userid,
        username: decoded.username,
        role: decoded.role,
        companyId: decoded.companyid,
      };
    } catch {
      return null;
    }
  },
};
